// extracted by mini-css-extract-plugin
export default {"dialogs":"Dialogs_dialogs__37Zk0","dialogsItems":"Dialogs_dialogsItems__M6UdQ","active":"Dialogs_active__v00Je","messages":"Dialogs_messages__36LfF"};